import { put, call, select, takeLatest } from 'redux-saga/effects';
import {
    getStatusesRequest,
    getStatusesSuccess,
    getStatusesFailure,
    GET_STATUSES_REQUEST,
    GET_TRANSITIONS_REQUEST,
    getTransitionsSuccess,
    getTransitionsFailure
} from '../actions/statuses';
import { getStatuses, getTransitions } from '../services/statuses';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { statusesSelector } from "../selectors/statuses"

export const getStatusesWorker = function* ({ payload = {} } = {}) {
    try {

        const { type } = yield select(statusesSelector);

        yield put(getStatusesRequest());
        return yield call(getAllStatusesWorker, { payload: { ...payload, type } });
    } catch (err) {
        yield put(getStatusesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getTransitionsWorker = function* ({ payload: { status_id, filters = {}, type } = {} } = {}) {
    try {
      const token = yield select(accessTokenSelector);
  
      const {
        data: {
          statuses: { items }
        }
      } = yield call(getTransitions, status_id, filters, type, token);
      
      yield put(getTransitionsSuccess(items, type));
  
    } catch (err) {
      yield put(getTransitionsFailure(err));
      yield put(showGlobalError(true, err));
    }
  };
  

const getAllStatusesWorker = function* ({ payload: { filters = {}, type } = {} } = {}) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { statuses }
        } = yield call(getStatuses, filters, type, token);

        yield put(getStatusesSuccess(statuses, type));
    } catch (err) {
        yield put(getStatusesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [
    getStatusesWorker,
    takeLatest(GET_STATUSES_REQUEST, getAllStatusesWorker),
    takeLatest(GET_TRANSITIONS_REQUEST, getTransitionsWorker)
];
